import type { SubTask } from "../types";

export interface TodayBoardFocus {
  /** The open saved filter's only date rule is Today. */
  active: boolean;
  /** The task's own day is not today, so the card is only context. */
  parentOutsideToday: boolean;
}

const INACTIVE: TodayBoardFocus = { active: false, parentOutsideToday: false };

/** True when every chosen date rule is Today. Other date rules keep the old card. */
export function isTodayOnlyDateFilter(dateFilters: readonly string[] | undefined): boolean {
  return !!dateFilters && dateFilters.length > 0 && dateFilters.every((value) => value === "today");
}

/**
 * A Today-only saved filter. Search on the web replaces that filter, so the
 * card stays normal while a search is open.
 */
export function todayBoardFocus(input: {
  searchTerm: string;
  activeFilterId: string | undefined;
  dateFilters: readonly string[] | undefined;
  scheduledDate: string | null;
  /** A completed task already looks faded. It is not also marked as context. */
  completed?: boolean;
  today: string;
}): TodayBoardFocus {
  if (input.searchTerm.trim()) return INACTIVE;
  if (!input.activeFilterId || !isTodayOnlyDateFilter(input.dateFilters)) return INACTIVE;
  return {
    active: true,
    parentOutsideToday: !input.completed && input.scheduledDate !== input.today,
  };
}

/** Sub-tasks the board card lists. A Today filter keeps only that day. */
export function visibleBoardSubtasks(
  subtasks: readonly SubTask[],
  showCompleted: boolean,
  focus: TodayBoardFocus,
  today: string,
): SubTask[] {
  return subtasks.filter((subtask) => {
    if (!showCompleted && subtask.completed) return false;
    if (focus.active && subtask.scheduled_date !== today) return false;
    return true;
  });
}
